import { projectsList } from "../../constant/ProjectsData";
import { Link } from "react-router-dom";
import { PhotoProvider, PhotoView } from "react-photo-view";
import useWindowWidth from "../../../../Hooks/useWindow.js";
import { useEffect, useState } from "react";
import useApiRequest from "../../../../Hooks/apiReq.js";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader.jsx";
import { useSelector } from "react-redux";
const Projects = () => {
  const width = useWindowWidth();
  const [projectlist, setProject] = useState([]);
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const getProjectList = () => {
    const payload = {
      DeviceType: "Web",
    };
    sendApiRequest("POST", "/Dashboard/GetProjectList", payload, {
      onSuccess: (res) => {
        const jsonData = res?.data?.jsonData
          ? JSON.parse(res?.data?.jsonData)
          : [];
        setProject(jsonData);
      },
    });
  };
  const appType = useSelector((state) => state?.uiReducers?.appType);
  useEffect(() => {
    if (appType === "Business") getProjectList();
  }, [appType]);
  if (projectlist.length < 1) {
    return null;
  }
  return (
    <div className="col-12 col-xl-6 col-xxl-6">
      <div className="card border h-100 w-100 overflow-hidden">
        {loading && <SpinnerLoader />}
        <div className="card-body p-2">
          <div class="card-title mb-1 border-1 border-bottom">
            <h4 class="text-body-emphasis text-color">
              {" "}
              <i class="bi bi-grip-vertical "></i>Project
            </h4>
          </div>
          <ul className="goal-icon2">
            {projectlist.map((project, idx) => (
              <li key={idx} className={width > 780 ? `` : ` w-50`}>
                <Link href="#" className="">
                  <PhotoProvider>
                    <PhotoView src={project?.Logo}>
                      <img
                        src={project?.Logo}
                        className="card-img-top  img-fluid gallery-img rounded"
                        loading="lazy"
                        style={{
                          cursor: "pointer",
                          height: "220px",
                          width: "100%",
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                          backgroundColor: "#fff",
                        }}
                        title="Click To View"
                      />
                    </PhotoView>
                  </PhotoProvider>
                  <strong className="text-start text-success fw-bolder">
                    {project?.Title}{" "}
                  </strong>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Projects;
